module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theatre Royal, Drury Lane, London, England, 1885")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v("sabella O’Toole’s life swept from one tragedy to another. And she loved every dramatic, heart-wrenching moment. Singing opera, as her mother once said, was in her blood. No matter the setting or situation, Bella always wept for her doomed heroines.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Tonight, however, there was an added layer of emotion that had nothing to do with tragedy. The sensation left Bella with a dull headache and unusually raw emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He was here. In the audience. Watching her—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only her")]), _vm._v("—with the intense stare that never failed to steal her breath away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("The moment the curtain made its final descent her first impulse was to run to her dressing room and prepare for his visit. But that would be self-indulgent, ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("a trait she disliked in others and thoroughly despised in herself. Somehow, she found the patience to offer congratulations to her fellow cast members with a genuine smile on her lips.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Still, in the back of her mind she was well-aware that he beckoned and there was little time left to prepare. She offered a quick hug to her understudy, and began the brief journey to her dressing room. Much to her amusement, she caught herself nearly running by the time she arrived at her destination. So much for dignity and grace under pressure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With an impatient shove, Bella shut the door behind her and leaned against the sturdy wood. Thoughts of William filled her mind. Her heart pounded, her hands shook.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Conflicting emotions tangled inside one another, threatening to overwhelm her. Despite the joy of seeing William again, she was still on edge after playing Isolde. No matter how many times Bella sang the shifting chords in the final aria, the music rent every bit of emotion from her. She was exhausted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Trying to force calm into her thinking, she breathed in and out. Tonight was too special, too important to allow grief for a fictional heroine’s lost love to engulf her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At last, the drumming in her heart shifted and she looked around the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her refuge.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("The one place solely hers, where she morphed herself from Bella O’Toole, youngest in the famous O’Toole acting family, into the most acclaimed opera singer of her day. With grace and comfort in mind, she’d deco")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("rated her small space by paying close attention to details and fuss. Intricate lace, fresh flowers and soft, cushiony furniture created a tone that was warm, feminine and fashionable.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("To add a touch of glamour, Bella only used candles, preferring the soft golden glow and warm scent of the wax to the bleak ambiance provided by modern gas lamps. Perhaps she did have her moments of self-indulgence. But she tried to contain them to these small facets of her life instead of giving rein to the wild emotions that sometimes seized her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Pushing from the door, Bella ran her finger along the edges of her makeup table, across the rims of the various jars of creams and rouge. Tools of her trade. Where she donned the mask of her characters and became the tragic heroines only found in the opera.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She spun in a circle and let dreams fill her head. Dreams of what life would be like if William proposed to her at last. Unlike the characters she portrayed, her love story would have a happy ending.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The charming, handsome viscount had been persistent in his pursuit of her over these last two months, often pushing for favors they both knew she would not give him until their wedding night. She was afraid, afraid he would come to mean more to her than she could handle. Afraid she would forget her moral upbringing and allow emotion to overpower her good sense. He already drew feelings out of her that no one else had.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("In truth, his polished sophistication troubled her. Although she’d been raised in the theater, traveling with ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("her famous parents and talented siblings across continents, she wasn’t as worldly as Lord Crawley. Her parents had sheltered her from the uglier side of their profession. Reginald and Patience O’Toole had raised their children with Christian values and a strong knowledge of Scripture.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella often felt much younger than her twenty-four years. She missed her family. Especially now, when she desperately needed someone to talk to about her handsome viscount. Her mother or brother, Beau, would know what words to use to settle her unease, or rather what Scripture.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, Lord,")]), _vm._v(" she prayed, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("guide me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Whatever happens, conduct yourselves in a manner worthy of the gospel of Christ. Then, I will know you stand firm….")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The words from Paul to the Philippians gave her confidence. Changing out of her costume would give her more. Bella bit back a sigh. With unsteady fingers, she quickly shed Isolde’s medieval costume and changed into the dress she’d worn to the theater. The locket William had given her hung beneath the lace collar, warming her skin and reminding Bella of the viscount’s deep affection, a tangible symbol of his love for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Sighing, she removed her stage makeup and laced up her boots. There was nothing left to do but wait.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As if on cue, the expected knock came at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("In spite of her efforts to remain calm and mature, a jittery surge of excitement tickled the base of her spine and she fingered the locket. “Enter,” she said on a breathy whisper.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The door swung open. Bella’s pulse drummed in her ears as her gaze connected with the man she loved. William Gordon. Lord Crawley. As she drank in the sight of her viscount immaculately dressed in black tails, she tried to look past the title and straight to the man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He was tall and lean, his face aristocratic with a strong cut of cheekbones under deep-set blue eyes. Even the stark white of his shirt set off his dark good looks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("An unhurried smile drifted along his lips and he reached out his hand to her. Her pulse tripped, slowed to a near stop then quickened again. Tossing her head back, she started toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He shut the door with a jab of his elbow and then lifted a single eyebrow at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Alone. They were all alone. Her stomach rolled over itself, but Bella continued forward. The click of her heels echoed across the parquet floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("William was so appealing she wanted to rush her steps. She restrained herself. A moment like this required confident, liquid grace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Tenderness and genuine appreciation mingled in his gaze before he covered his reaction with an unreadable expression. Her heart leapt to her throat and stuck. William Gordon was always kind, generous, quick-witted and charming. The sort of man a woman waited all her life to find. But he was also a man filled with hidden depths. And staring at her now, with such intensity, she realized he had a suggestion of danger about him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With that thought, her steps slowed. She stopped a foot away from him and placed her palm in his.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“My beautiful, talented Bella,” he said, lifting her hand to his lips. “You were magnificent this evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A jolt of impatience whipped through her at his standard compliment, but Bella hid the emotion behind a dazzling smile. Pleasantries first, sincerity later. That was their pattern. “Thank you, William.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He stared at her for a long moment, saying nothing. Seconds ticked by with only the sound of their breathing filling the barren silence. Bella’s lack of experience with men made her unsure how to fill the awkward moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Searching for a clue as to how to proceed, she stared into his handsome face. A sudden gust of wind threw open the window behind her, blowing out the candles closest to her. Shadows filled half the room, concealing William’s face. She thought she saw a flicker of something different in his eyes, something a little dark. A little unsettling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A shiver iced across her skin and she felt the first stirrings of concern. Drawing her bottom lip between her teeth, she wheeled around, shut the window and quickly relit the candles. As she moved through the room, she reminded herself that this was her William. She knew him well. The realization settled her nerves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Where would you like to dine this evening?” His gaze shifted to the divan as he strolled toward her. “Or would you prefer to stay in?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella looked around her dressing room. She eyed the soft lighting, breathed in the scent of a spring garden, noted the many pillows strewn on the divan. From a certain perspective one might mistakenly believe she’d prepared for something…illicit.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I think we should go out,” she said, flashing him a bright smile. “Celebrate my magnificent performance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She’d hoped to make him laugh but his face remained impassive, and his shoulders stiffened. He drew her close to him and took both her hands in his.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Tonight could be very special for us, my dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The sleepy charm in his manner pulled her a step closer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He tightened his fingers around hers and commanded her gaze. “A beginning, if you will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("In spite of his pleasant tone, Bella couldn’t shake the notion that something strange was creeping into their conversation, something sordid. She withdrew one hand and then another. “I—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Let us drop these pretenses at last.” He shoved shaking fingers through his hair and started pacing along the edge of the Venetian rug. “You are too good for the theater.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He took her elbow and steered her to the divan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Unsure of his motives, she slid away from him and perched against her dressing table instead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I have always dreamed of more,” she said, her voice sounding as tentative as she felt. Where was this leading?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He opened his mouth to speak, then clamped his jaw shut as though he was considering his next words carefully. His breath came out in a ragged sigh. She feared his next words would define their fate and she wasn’t sure she wanted to know the outcome.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At last, he nodded as if he’d come to some decision, rubbed his hand across his mouth and resumed his pacing. “It’s good you want something other than the theater.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("The satisfaction that shone in his eyes was at odds ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("with the tenseness in his movements. She’d never seen him quite so edgy. “William?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Let me provide for you properly,” he blurted while never missing a step. “In the style and comfort you deserve.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His words staggered her and she found she had to clutch the side of her makeup table to steady herself. “Are you asking for my hand?” she asked, but she feared she already knew the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He stopped pacing, turned to look at her with a frown marring his brow. “Marriage? You thought I came to offer marriage?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His voice held genuine shock, as though the notion had never crossed his mind. She had to fight a wave of hysteria as she stared at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You said you loved me,” she said at last, touching the hidden locket with her fingertip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He rushed to her, knelt at her feet and clasped her hands in his again. “I do love you, Bella.” His breathing came in hard, shallow spurts. “It is why I offer my protection. It is the greatest gift I have to give.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He was no longer the suave viscount, but a man too desperate to have his way to remember his rank. The thought brought her no comfort, no hope. Only anguish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She pressed her lips together to keep from sobbing and closed her eyes. Her heart pounded in her ears. “You think that little of me, of us, that you would make me your mistress?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He squeezed her hands gently. “Look at me,” he coaxed with his low, soothing baritone back in place.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She didn’t think she had the courage, yet she forced open her eyes. The sincerity in his returning gaze gave her hope.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She held her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You deserve better than marriage, my love. I would never relegate you to the role of wife. It’s nothing more than a gilded cage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She lowered her eyes and said nothing, knowing no response was necessary. Very carefully, very slowly, she pulled her hands from his and straightened. He stood, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“As an opera singer, I am not good enough to become your wife.” She tilted her head to stare at him. “Is that what you are saying, William?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I love you too much to imprison you.” He rose to his full height and continued. “As my mistress, you would have certain freedoms my wife could never have. I would give you a notice of carte blanche. You will never again incur a debt and will live a life of complete luxury.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The haughty tone of his words conflicted with the desperation she saw in his gaze. He looked so young, staring at her with those startling blue eyes. So sincere. As though he’d just offered her the most precious gift in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Yet, you don’t love me enough to marry me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He clasped his hands behind his back and drew in a long breath. “I already have a wife.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Bella gasped and her hand clutched at her throat. Her fingers brushed the locket which now weighed heavy around her neck. Chills swept across her skin, ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("followed by scorching heat. Unable to speak, she stumbled backward until her spine hit the door leading to freedom. She dropped her gaze to her toes. From the hallway, a beam of light shone like a beacon under the door. She wanted to run from the ramifications she could not yet face, but that would make her a coward. Thus, she found the courage to demand further explanation. “You’ve pursued me all these months, while already married?”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“What I am offering is far more than marriage.” He stood tall, head erect. His stance was full of aristocratic pride but his gaze held a silent plea. “Think of it, Bella, you will be the celebrated mistress of a viscount in his own right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("How could he think he offered her something of value, when it meant the desecration of his wedding vows? These long months of pursuit she’d held him at arm’s length, had remained pure, all the while assuming he respected her as very few men respected women in her profession.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She’d been woefully mistaken. He hadn’t been courting a wife. He’d been seducing a mistress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She had just enough pride left to be furious at him. “I would like you to leave now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Rage and anguish, guilt and love tangled in his gaze. “Bella, no, don’t make a hasty decision. I love you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("His eyes begged her to believe him, and to her shame, she wanted to do just that. Hadn’t she felt his admiration, respect and love grow deeper these past weeks? Was this how Bathsheba had felt when King David had ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("pursued her? Was David’s love so real and desperate, his arguments so convincing that Bathsheba willingly walked into sin with him?")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella had never felt pity for the woman who committed such a brazen act of adultery. Until now. Heaven help her, Bella still loved William.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("But the emotion shamed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Perhaps if she found the strength to walk away she could redeem them both. “I cannot accept your offer, William.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I will not lose you, Bella. You are my greatest desire, I will die without you. I know I can make you happy. You will never want for anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Desire? Want? Was that how he defined love? She kept her head lowered to hide the spark of anger. At him. At herself for feeling such sorrow over her loss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Marriage was sacred. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Therefore, what God has joined together, let no man put asunder.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I will not turn into an adulterer this night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("But she knew, in her heart, the deed was already done. Hadn’t Jesus said that the thought alone made her accountable for the sin?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Apparently unaware of her turmoil, William turned his back to her, idly fiddled with the wax on a candle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I have pursued you these two months, have I not, with the benefit of nothing more than your smiles?” He sent her a shrewd glance over his shoulder, shifted to face her. “I honored your purity when I could have had any number of mistresses by now. I want you, Bella. The way a man wants a woman.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With each word he spoke, her disgrace grew. The room was suddenly hot, so hot she feared she would faint.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Dry eyes were her only defense. “I cannot become your mistress. I will not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A range of emotions crossed his face again, more subtle and harder to read. The eyes that locked with hers were sharp and measuring. She knew he was calculating how best to win her. A wager he’d already lost. Bella would not harm an innocent woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At that thought, her mind was suddenly clearer. So clear it hurt. The churning in her stomach was humiliation, she knew. But she would survive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Unfortunately, shame was a bitter taste on her tongue, one she feared would never go away. It helped to remind herself that she was not the victim here. Lord Crawley’s wife bore that burden alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Bella,” he pleaded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Their stares locked, held. He was so handsome. And she loved him so much. Even now. Still. Self-directed anger and misery bubbled up, but Bella forced it back with a hard swallow. She had to come up with a plan to get him to leave before she agreed to do something she already knew she’d regret. It was her only hope of salvation. “I need time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A flicker of hope pulled his lips into a soft smile. “I understand.” He drew her hand to his lips. “But make your decision quickly. I have been patient long enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was a caddish remark, but Bella saw genuine emotion in the flash of anxiety that wavered in his eyes. In that moment, Bella realized he loved her. Truly loved her.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Yet, he would never understand her. His upbringing had taught him duty and possession and broken vows. Hers had taught her the sacredness of marriage and loyalty and obedience to Christ, her Lord and Savior.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With that last thought, her humiliation burned deeper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She knew what she had to do now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It was only years of training that enabled her to look him in the eyes without breaking into tears, knowing this was the end. “Allow me one day to consider.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He dropped her hand. A smile hinting at his confidence slithered across his lips. “I will return before noon tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She nodded. “Tomorrow, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A knot twisted in her stomach as she watched him walk out the door. There would be no additional meeting. Her only chance was escape. And she knew just the place to run, a place where William would never dare to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A small victory, to be sure, but hardly an honorable one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She could only hope with distance and time, absolution would come.")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-855505a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lovingbella_fm02.vue
// module id = 78
// module chunks = 0